import { connectNetwork } from 'lib/NetworkProvider'
import { routes, route_from } from 'lib/routes'
import View from 'lib/View'
import moment from 'moment-with-locales-es6'
import { Range } from 'rc-slider'
import React, { Component } from 'react'
import Moment from 'react-moment'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Button, Card, Icon } from 'semantic-ui-react'
import { floatTimeToPaddedString } from '../lib/util'
import { Confirmation } from '../components'

const { app, turns, turnEdit } = routes

moment.locale('it')
Moment.globalMoment = moment
Moment.globalLocale = 'it'

class Turn extends Component {
    constructor(props) {
        super(props)
        let { turn } = props

        this.state = {
            colors: ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'grey', 'black'],
            pwModal: false,
            ...turn,
        }
    }

    openRemoveDialog() {
        this.setState({ deleting: true })
    }

    remove() {
        let { network, turn } = this.props

        network.deleteTurn(turn)

        this.setState({ deleting: false })
    }

    handleInput(event) {
        const target = event.target
        const value = target.type === 'checkbox' ? target.checked : target.value
        const name = target.name

        console.log('Handling input', name, target, event)

        this.setState({
            [name]: value,
        })
    }

    render() {
        let { type } = this.props
        let { deleting, turnId, turnName, start, length } = this.state
        let extraprops = {
            fluid: type === 'full' ? true : false,
        }

        let end = start + length
        let startstring = floatTimeToPaddedString(start)
        let endstring = floatTimeToPaddedString(end)
        let range = [start, start + length]

        let col = parseInt(Math.random() * this.state.colors.length)

        let marks = {}

        for (let i = 0; i <= 24; i += 1) {
            let hours = Math.floor(i)
            let minutes = i % 1
            if (minutes < 10) minutes = `0${minutes}`
            marks[i] = <span>{hours}</span>
        }

        switch (type) {
            default:
                return (
                    <View fullw column between>
                        <Card style={styles.jobCard} {...extraprops} color={this.state.colors[col]}>
                            <Confirmation
                                message="Vuoi davvero eliminare questo turno?"
                                showModal={deleting}
                                onConfirm={() => {
                                    this.remove()
                                }}
                                onCancel={() => {
                                    this.setState({ deleting: false })
                                }}
                            />
                            <Card.Content style={styles.jobContent}>
                                <View fullw row>
                                    <View fullw column>
                                        <Card.Header>
                                            <span style={styles.header}>{turnName}</span>
                                            <span
                                                style={{
                                                    marginLeft: '16px',
                                                    fontSize: '18pt',
                                                    color: 'grey',
                                                }}
                                            >
                                                Dalle {startstring.fullstring} alle {endstring.fullstring}
                                            </span>
                                        </Card.Header>
                                        <Card.Description>
                                            <Range
                                                style={{ height: 50, marginTop: 8 }}
                                                value={range}
                                                defaultValue={[start, start + length]}
                                                min={0}
                                                max={24}
                                                step={0.5}
                                                pushable={true}
                                                dots={true}
                                                marks={marks}
                                                activeTrackStyle={{
                                                    backgroundColor: 'green',
                                                }}
                                                handleStyle={{
                                                    backgroundColor: 'yellow',
                                                }}
                                            />
                                        </Card.Description>
                                    </View>
                                </View>
                            </Card.Content>
                            <Card.Content extra>
                                <Button
                                    color="blue"
                                    onClick={() => {
                                        this.props.history.push(route_from(app, turns, turnEdit, `${turnId}`))
                                    }}
                                >
                                    <Icon name="edit" />
                                    Modifica
                                </Button>
                                <Button
                                    color="red"
                                    onClick={() => {
                                        this.openRemoveDialog()
                                    }}
                                >
                                    <Icon name="delete" />
                                    Elimina
                                </Button>
                            </Card.Content>
                        </Card>
                    </View>
                )
        }
    }
}

const styles = {
    header: {
        fontSize: '40pt',
        lineHeight: 'normal',
    },
    imageContainer: {
        width: 200,
        height: 150,
        marginRight: 28,
    },
    jobImage: {
        width: 200,
        height: 150,
        objectFit: 'contain',
    },
    jobContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    jobCard: {
        marginTop: 8,
        marginBottom: 8,
    },
}

const mapStateToProps = (state) => {
    let { login } = state
    let rcode = null
    if (login && login.data && login.data.turn) rcode = login.data.turn.rcode

    return { role: rcode }
}

export default withRouter(connect(mapStateToProps)(connectNetwork(Turn)))
